import createReactComponent from '../createReactComponent';
export default createReactComponent('mobile-signal-four', 'MobileSignalFour', [["path",{"d":"M3 21v-1m9 1v-9m4.5 9V8m-9 13v-5","key":"svg-0"}]]);